import { z } from 'zod';

export const CaseLogScalarFieldEnumSchema = z.enum(['caselogId','cityId','caseId','staff','infoOnly','fromId','toId','message','dateSent','atachments','externalId','rowTimestamp']);

export default CaseLogScalarFieldEnumSchema;
